<template>
  <v-container class="pa-0">
    <v-row no-gutters>
      <v-col cols="12">
        <FormHeader title="URLS" />
      </v-col>
    </v-row>
    <v-container class="white">
      <v-row no-gutters align="baseline" class="pb-3">
        <v-col cols="4">
          <v-row
            no-gutters
            :class="{
              'pl-7': hasVNC
            }"
          >
            <v-col cols="12">
              <v-subheader>URL</v-subheader>
            </v-col>
            <v-col cols="12" class="d-none d-sm-flex">
              <v-subheader class="caption notice" v-if="noticeMsg">
                Please ensure that the Page IDs are unique per URL
              </v-subheader>
            </v-col>
          </v-row>
        </v-col>
        <v-col cols="2">
          <v-row>
            <v-col cols="12">
              <v-subheader>PATH</v-subheader></v-col>
            <v-col cols="12">
<!--              <v-subheader>Should start with slash, example: /gampad/ads?gd...</v-subheader>-->
            </v-col>
          </v-row>
        </v-col>
        <v-col cols="2">
          <v-subheader>PAGE ID</v-subheader>
        </v-col>
        <v-col cols="4">
          <v-row no-gutters v-if="hasVNC">
            <v-col cols="12">
              <v-subheader>STOP RECORDING SETTINGS</v-subheader>
            </v-col>
            <v-col cols="12" class="d-none d-sm-flex">
              <v-subheader class="caption notice">
                It will stop after X secs
              </v-subheader>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
      <v-layout v-for="(v, index) in url.$each.$iter" :key="index">
        <v-row no-gutters align="baseline">
          <v-col cols="4" class="pl-4 d-inline-flex">
            <v-subheader class="pb-2 pl-0" v-if="hasVNC">{{
              index * 1 + 1
            }}</v-subheader>
            <v-autocomplete
              :items="getUrlList"
              placeholder="Select URL"
              dense
              single-line
              outlined
              required
              return-object
              item-value="id"
              item-text="url"
              @blur="v.domain.$touch()"
              :error-messages="errorMessages.requiredErrors(v.domain)"
              v-model="v.domain.$model"
              eager
            ></v-autocomplete>
          </v-col>
          <v-col cols="2" class="pl-4">
            <v-text-field
              v-bind:id="index + '-path'"
              v-model="v.path.$model"
              name="path"
              type="text"
              single-line
              outlined
              dense
              placeholder="/example"
            ></v-text-field>
          </v-col>
          <v-col cols="2" class="pl-4 input-72 d-inline-flex" v-if="!isAdsSelected">
            <v-select
              :items="getPageIdList"
              placeholder="Select ID"
              dense
              single-line
              outlined
              required
              item-value="id"
              item-text="name"
              @blur="v.page_id.$touch()"
              :error-messages="errorMessages.requiredErrors(v.page_id)"
              v-model="v.page_id.$model"
              eager
            ></v-select>
          </v-col>
          <v-col cols="2" class="pl-4 input-72 d-inline-flex" v-if="isAdsSelected">
            <v-text-field
              v-bind:id="index+'-pageId'"
              required
              @focus="v.page_id.$touch()"
              @blur="v.page_id.$touch()"
              :error-messages="errorMessages.requiredErrors(v.page_id)"
              v-model="v.page_id.$model"
              name="page_id"
              type="text"
              placeholder="000"
              single-line
              outlined
              dense
            ></v-text-field>
          </v-col>
          <v-col cols="3" class="pl-4 input-72 d-inline-flex">
            <v-text-field
              v-if="hasVNC"
              v-bind:id="index+'stop_recording_after'"
              required
              @focus="v.stop_recording_after.$touch()"
              @blur="v.stop_recording_after.$touch()"
              :error-messages="
                errorMessages.integerErrors(v.stop_recording_after)
              "
              v-model.number="v.stop_recording_after.$model"
              name="stop_recording_after"
              type="text"
              single-line
              outlined
              dense
              placeholder="00"
              maxLength="2"
            >
            </v-text-field>
          </v-col>
          <v-col cols="1" class="pl-4 d-inline-flex">
            <v-btn
              icon
              v-if="hasVNC && Object.keys(url.$each.$iter).length !== 1"
            >
              <v-icon @click="deleteItem(index)">mdi-delete</v-icon>
            </v-btn>
          </v-col>
        </v-row>
      </v-layout>
      <Button
        v-if="hasVNC"
        v-on:onClick="addNewUrl()"
        class="ml-10 mb-5 mt-1"
        :red-btn="true"
        :content="`ADD NEW URL`"
      />
    </v-container>
  </v-container>
</template>

<script>
import FormHeader from "./FormHeader";
import { URL_FORM_DELETE_CONFIRM } from "../../utils/constants";
import { createNamespacedHelpers } from "vuex";
import Button from "../common/Button";
const formHelper = createNamespacedHelpers("form");
export default {
  name: "UrlForm",
  components: {
    FormHeader,
    Button
  },
  props: {
    hasVNC: {
      type: Boolean,
      default: true
    },
    errorMessages: {
      type: Object,
      required: true
    },
    url: {
      type: Object,
      required: true
    },
    noticeMsg: {
      type: Boolean,
      required: true
    },
    showPageId: {
      type: Boolean,
      default: true
    },
    scanType: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    ...formHelper.mapGetters(["getUrlList","getPageIdList"])
  },
  methods: {
    addNewUrl() {
      this.url.$model.push({
        path: "",
        domain: {},
        stop_recording_after: "",
        page_id: ""
      });
    },
    deleteItem(index) {
      confirm(URL_FORM_DELETE_CONFIRM) && this.url.$model.splice(index, 1);
    },
    ifAdsSelected(value) {
      if(value) {
        value.forEach(item => {
          if(item.checked) {
            this.isAdsSelected = item.value === "realtime-ads" || item.value === "ads";
          }
        })
      } else {
        this.scanType.forEach(item => {
            if(item.checked) {
              this.isAdsSelected = item.value === "realtime-ads" || item.value === "ads";
            }
        })
      }
    }
  },
  data: function () {
    return {
      isAdsSelected: false,
    }
  },
  watch : {
    scanType : function (value) {
      this.ifAdsSelected(value)
    }
  },
  created() {
    this.ifAdsSelected();
  }
};
</script>
